// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1480":"4dd524b2","5381":"86ff5edf"}[chunkId] + ".chunk.css";
};